import React from 'react';
import {Grid, GridCol, spaceHelpers} from '@flixbus/honeycomb-react';
import {useReadOnlyKpiInputConfigBuilder} from '../../../../hooks/useReadOnlyKpiInputConfigBuilder';
import ReadOnlyInput from '@/components/ReadOnlyInput/ReadOnlyInput';
import {LineScheduleVehicleKpisListProps} from './LineScheduleVehicleKpisList.types';
import {LineScheduleVehicleKpisConfig} from './LineScheduleVehicleKpisList.data';

const LineScheduleVehicleKpisList: React.FC<
  LineScheduleVehicleKpisListProps
> = ({kpis}) => {
  const inputs = useReadOnlyKpiInputConfigBuilder(
    kpis ?? null,
    LineScheduleVehicleKpisConfig
  );
  const {2: space2, 3: space3} = spaceHelpers();

  if (!inputs.length) return null;

  return (
    <Grid extraClasses={`${space3.top} ${space2.left} ${space2.right}`}>
      {inputs.map(input => (
        <GridCol size={3} key={input.id}>
          <ReadOnlyInput
            extraClasses="content-secondary-color"
            horizontal
            {...input}
          />
        </GridCol>
      ))}
    </Grid>
  );
};

export default React.memo(LineScheduleVehicleKpisList);
